const authorityAdd = () => import('@/views/main/authority/add/add.vue')
export default {
  path: '/main/authority/add',
  name: 'authorityAdd',
  component: authorityAdd,
  children: []
}
